// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.staff-accept-invitation-modal__container{
    background-color: var(--new-background-color);
}
.staff-accept-invitation-modal__container .modal__container{
    padding: unset;
    max-width: unset;
    width: 40%;
}

.staff-accept-invitation-modal__content{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 48px;
}


.staff-accept-invitation-modal__tournament-info{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 34px;
    gap: 16px;
}

.staff-accept-invitation-modal__tournament-info .baloa-subtitle-1{
    color: var(--primary-very-dark-color);
}

.staff-accept-invitation-modal__tournament-info .baloa-normal{
    color: var(--primary-dark-color);
}

.staff-accept-invitation-modal__buttons{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.staff-accept-invitation-modal__buttons-button{
    margin-top: 66px        ;
    margin-bottom: 24px;
}

.staff-accept-invitation-modal__buttons .baloa-table-column{
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .staff-accept-invitation-modal__container .modal__container{
        width: 100%;
    }

    .staff-accept-invitation-modal__content strong{
        display: contents;
    }

    .staff-accept-invitation-modal__content {
        padding: var(--space-x2) var(--space);
    }

}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/staff-accept-invitation-modal/StaffAcceptInvitationModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qCAAqC;IACzC;;AAEJ","sourcesContent":[".modal.staff-accept-invitation-modal__container{\n    background-color: var(--new-background-color);\n}\n.staff-accept-invitation-modal__container .modal__container{\n    padding: unset;\n    max-width: unset;\n    width: 40%;\n}\n\n.staff-accept-invitation-modal__content{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    padding: 48px;\n}\n\n\n.staff-accept-invitation-modal__tournament-info{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 34px;\n    gap: 16px;\n}\n\n.staff-accept-invitation-modal__tournament-info .baloa-subtitle-1{\n    color: var(--primary-very-dark-color);\n}\n\n.staff-accept-invitation-modal__tournament-info .baloa-normal{\n    color: var(--primary-dark-color);\n}\n\n.staff-accept-invitation-modal__buttons{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.staff-accept-invitation-modal__buttons-button{\n    margin-top: 66px        ;\n    margin-bottom: 24px;\n}\n\n.staff-accept-invitation-modal__buttons .baloa-table-column{\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .staff-accept-invitation-modal__container .modal__container{\n        width: 100%;\n    }\n\n    .staff-accept-invitation-modal__content strong{\n        display: contents;\n    }\n\n    .staff-accept-invitation-modal__content {\n        padding: var(--space-x2) var(--space);\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
